import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="28sur4e8bzhhi">
      <div lang="fr" className="w-full bg-paper font-sans text-ink antialiased" data-id="element-1" data-mp="23vkw8j26adma">
        <CountdownBar data-id="element-2" data-mp="23ti7e2craqj5" />
        <main data-id="element-3" data-mp="3ik7jmqgv0tve">
          <Hero data-id="element-4" data-mp="3ikqz80j1f669" />
          <StatsBar data-id="element-5" data-mp="3ij668fcdfvai" />
          <Difference data-id="element-6" data-mp="3ijpet5g4t7bv" />
          <Recognize data-id="element-7" data-mp="3mljaezbgzl56" />
          <WhatsInside data-id="element-8" data-mp="3ml1234bj9ggw" />
          <InsidePages data-id="element-9" data-mp="3mk868ye44bdj" />
          <Bonuses data-id="element-10" data-mp="3mjpyp5m02aqb" />
          <Offer data-id="element-11" data-mp="3rc9f0ac2njyt" />
          <Guarantee data-id="element-12" data-mp="3rbr9so7flver" />
          <Testimonials data-id="element-13" data-mp="3rdaselgk8ijp" />
          <Faq data-id="element-14" data-mp="3rd1all5o5hp3" />
        </main>
        <Footer data-id="element-15" data-mp="5yimri0b7dt" />
      </div>
    </MotionConfig>;
}